class BiltongBoysCaseOptions {
  constructor(container) {
    this.container = container;
    this.form = container.closest('form');

    if (!this.form) return;

    this.options = Array.from(
      container.querySelectorAll('[data-bb-case-option]')
    );

    this.quantityInput = this.form.querySelector('[data-bb-cart-quantity]');
    this.caseLabelInput = this.form.querySelector('[data-bb-case-label]');
    this.pieceCountInput = this.form.querySelector('[data-bb-piece-count]');
    this.fractionInput = this.form.querySelector('[data-bb-fraction-value]');

    this.card = this.form.closest('[data-bb-product-card]');
    this.displayPrice = this.card?.querySelector('[data-bb-selected-price]');
    this.buttonLabel = this.form.querySelector('[data-bb-button-label]');

    this.moneyFormat =
      container.dataset.moneyFormat || '${{amount}}';

    this.bindEvents();
    this.applySelectedOption();
  }

  bindEvents() {
    this.options.forEach((option) => {
      option.addEventListener('change', () => {
        this.applyOption(option);
      });
    });
  }

  applySelectedOption() {
    const selectedOption =
      this.options.find((option) => option.checked) || this.options[0];

    if (selectedOption) {
      selectedOption.checked = true;
      this.applyOption(selectedOption);
    }
  }

  applyOption(option) {
    const quantity = Number.parseInt(option.dataset.quantity, 10);
    const price = Number.parseInt(option.dataset.price, 10);
    const fraction = option.value;
    const label = option.dataset.label || 'Case';

    if (!Number.isInteger(quantity) || quantity < 1) return;
    if (!Number.isInteger(price) || price < 0) return;

    if (this.quantityInput) {
      this.quantityInput.value = String(quantity);
    }

    if (this.caseLabelInput) {
      this.caseLabelInput.value = label;
    }

    if (this.pieceCountInput) {
      this.pieceCountInput.value = String(quantity);
    }

    if (this.fractionInput) {
      this.fractionInput.value = fraction;
    }

    if (this.displayPrice) {
      this.displayPrice.textContent = this.formatMoney(price);
    }

    if (this.buttonLabel) {
      this.buttonLabel.textContent = `Add ${label.toLowerCase()}`;
    }
  }

  formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);

    return this.moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(
        /\{\{\s*amount_no_decimals\s*\}\}/g,
        String(Math.round(cents / 100))
      )
      .replace(
        /\{\{\s*amount_with_comma_separator\s*\}\}/g,
        amount.replace('.', ',')
      )
      .replace(
        /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
        String(Math.round(cents / 100))
      );
  }
}

function initialiseBiltongBoysCaseOptions(root = document) {
  root.querySelectorAll('[data-bb-case-options]').forEach((container) => {
    if (container.dataset.bbInitialised === 'true') return;

    container.dataset.bbInitialised = 'true';
    new BiltongBoysCaseOptions(container);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initialiseBiltongBoysCaseOptions();
});

document.addEventListener('shopify:section:load', (event) => {
  initialiseBiltongBoysCaseOptions(event.target);
});